<template>
  <ul class="menu-nav">
    <router-link
      to="/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">Консоль</span>
        </a>
      </li>
    </router-link>



    <li class="menu-section">
      <h4 class="menu-text">Магазин</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item menu-item-submenu"
            v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon fas fa-cube"></i>
        <span class="menu-text">Товары</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Товары</span>
            </span>
          </li>

          <router-link
                  to="/products"
                  v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon fas fa-cubes"></i>
                <span class="menu-text">Все товары</span>
              </a>
            </li>
          </router-link>

          <router-link
                  :to="{ name: 'FormProduct', params: {action: 'add'}}"
                  v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon fas fa-plus-circle"></i>
                <span class="menu-text">Добавить</span>
              </a>
            </li>
          </router-link>

        </ul>
      </div>

    </li>

    <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item menu-item-submenu"
            v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon fas fa-list"></i>
        <span class="menu-text">Категории</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Категории</span>
            </span>
          </li>

          <router-link
                  to="/categories"
                  v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon fas fa-sitemap"></i>
                <span class="menu-text">Все категории</span>
              </a>
            </li>
          </router-link>

          <router-link
                  to="/category/add/category"
                  v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon fas fa-plus-circle"></i>
                <span class="menu-text">Добавить</span>
              </a>
            </li>
          </router-link>



        </ul>
      </div>

    </li>











    <router-link
            to="/attributes"
            v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-hashtag"></i>
          <span class="menu-text">Атрибуты</span>
        </a>
      </li>
    </router-link>


    <li class="menu-section">
      <h4 class="menu-text">CRM</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
            to="/orders"
            v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-cart-arrow-down"></i>
          <span class="menu-text">Заказы</span>
        </a>
      </li>
    </router-link>

    <router-link
            to="/clients"
            v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon far fa-address-card"></i>
          <span class="menu-text">Клиенты</span>
        </a>
      </li>
    </router-link>

    <router-link
        to="/order-tables"
        v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon far fa-address-card"></i>
          <span class="menu-text">Стол заказов</span>
        </a>
      </li>
    </router-link>

<!--    <router-link
            to="/coupons"
            v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-percent"></i>
          <span class="menu-text">Купоны</span>
        </a>
      </li>
    </router-link>-->

    <li class="menu-section">
      <h4 class="menu-text">Контент</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
            to="/pages"
            v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon far fa-file-alt"></i>
          <span class="menu-text">Страницы</span>
        </a>
      </li>
    </router-link>

    <router-link
            to="/files"
            v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-images"></i>
          <span class="menu-text">Файлы</span>
        </a>
      </li>
    </router-link>


    <li class="menu-section">
      <h4 class="menu-text">Сайт</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>


    <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item menu-item-submenu"
    >
    <a href="#" class="menu-link menu-toggle">
      <i class="menu-icon fas fa-sliders-h"></i>
      <span class="menu-text">Настройки сайта</span>
      <i class="menu-arrow"></i>
    </a>

    <div class="menu-submenu">
      <span class="menu-arrow"></span>
      <ul class="menu-subnav">
        <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Настройки сайта</span>
            </span>
        </li>

        <router-link
            to="/site-settings"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
          >
            <a :href="href" class="menu-link" @click="navigate">
              <i class="menu-icon fas fa-cog"></i>
              <span class="menu-text">Общие настройки</span>
            </a>
          </li>
        </router-link>

        <router-link
                to="/delivery-cities"
                v-slot="{ href, navigate, isActive, isExactActive }"
        >
          <li
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                  class="menu-item"
                  :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
          >
            <a :href="href" class="menu-link" @click="navigate">
              <i class="menu-icon fas fa-city"></i>
              <span class="menu-text">Города доставки</span>
            </a>
          </li>
        </router-link>



      </ul>
    </div>
    </li>

    <router-link
            to="/accounts"
            v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon fas fa-users"></i>
          <span class="menu-text">Аккаунты</span>
        </a>
      </li>
    </router-link>





    <li
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item menu-item-submenu"
            v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <i class="menu-icon fas fa-trash-alt"></i>
        <span class="menu-text">Архивы</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">Архивы</span>
            </span>
          </li>

          <router-link
                  to="/archive-products"
                  v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon fas fa-trash-alt"></i>
                <span class="menu-text">Товары</span>
              </a>
            </li>
          </router-link>


          <router-link
                  to="/archive-categories"
                  v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon fas fa-trash-alt"></i>
                <span class="menu-text">Категории</span>
              </a>
            </li>
          </router-link>

          <router-link
                  to="/archive-orders"
                  v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-icon fas fa-trash-alt"></i>
                <span class="menu-text">Заказы</span>
              </a>
            </li>
          </router-link>

        </ul>
      </div>

    </li>







<!--    <li class="menu-section">-->
<!--      <h4 class="menu-text">Инструменты</h4>-->
<!--      <i class="menu-icon flaticon-more-v2"></i>-->
<!--    </li>-->

<!--    <router-link-->
<!--            to="/builder"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--    >-->
<!--      <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--          isActive && 'menu-item-active',-->
<!--          isExactActive && 'menu-item-active'-->
<!--        ]"-->
<!--      >-->
<!--        <a :href="href" class="menu-link" @click="navigate">-->
<!--          <i class="menu-icon flaticon2-expand"></i>-->
<!--          <span class="menu-text">Layout Builder</span>-->
<!--        </a>-->
<!--      </li>-->
<!--    </router-link>-->

<!--    <li-->
<!--      aria-haspopup="true"-->
<!--      data-menu-toggle="hover"-->
<!--      class="menu-item menu-item-submenu"-->
<!--      v-bind:class="{ 'menu-item-open': hasActiveChildren('/vue-bootstrap') }"-->
<!--    >-->
<!--      <a href="#" class="menu-link menu-toggle">-->
<!--        <i class="menu-icon flaticon2-digital-marketing"></i>-->
<!--        <span class="menu-text">Vue Bootstrap</span>-->
<!--        <i class="menu-arrow"></i>-->
<!--      </a>-->
<!--      <div class="menu-submenu">-->
<!--        <span class="menu-arrow"></span>-->
<!--        <ul class="menu-subnav">-->
<!--          <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--            <span class="menu-link">-->
<!--              <span class="menu-text">Vue Bootstrap</span>-->
<!--            </span>-->
<!--          </li>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/alert"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Alert</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/badge"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Badge</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <li-->
<!--            aria-haspopup="true"-->
<!--            data-menu-toggle="hover"-->
<!--            class="menu-item menu-item-submenu"-->
<!--            v-bind:class="{-->
<!--              'menu-item-open': hasActiveChildren('/vue-bootstrap/button')-->
<!--            }"-->
<!--          >-->
<!--            <a href="#" class="menu-link menu-toggle">-->
<!--              <i class="menu-bullet menu-bullet-dot">-->
<!--                <span></span>-->
<!--              </i>-->
<!--              <span class="menu-text">Buttons</span>-->
<!--              <i class="menu-arrow"></i>-->
<!--            </a>-->
<!--            <div class="menu-submenu">-->
<!--              <span class="menu-arrow"></span>-->
<!--              <ul class="menu-subnav">-->
<!--                <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--                  <span class="menu-link">-->
<!--                    <span class="menu-text"></span>-->
<!--                  </span>-->
<!--                </li>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/button"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Button</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/button-group"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Button Group</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/button-toolbar"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Button Toolbar</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </li>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/card"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Card</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/carousel"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Carousel</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/collapse"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Collapse</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/dropdown"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Dropdown</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/embed"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Embed</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <li-->
<!--            aria-haspopup="true"-->
<!--            data-menu-toggle="hover"-->
<!--            class="menu-item menu-item-submenu"-->
<!--            v-bind:class="{-->
<!--              'menu-item-open': hasActiveChildren('/vue-bootstrap/form')-->
<!--            }"-->
<!--          >-->
<!--            <a href="#" class="menu-link menu-toggle">-->
<!--              <i class="menu-bullet menu-bullet-dot">-->
<!--                <span></span>-->
<!--              </i>-->
<!--              <span class="menu-text">Form</span>-->
<!--              <i class="menu-arrow"></i>-->
<!--            </a>-->
<!--            <div class="menu-submenu">-->
<!--              <span class="menu-arrow"></span>-->
<!--              <ul class="menu-subnav">-->
<!--                <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--                  <span class="menu-link">-->
<!--                    <span class="menu-text"></span>-->
<!--                  </span>-->
<!--                </li>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form-checkbox"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form Checkbox</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form-file"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form File</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form-group"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form Group</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form-input"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form Input</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form-radio"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form Radio</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form-select"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form Select</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/form-textarea"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Form Textarea</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </li>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/image"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Image</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/input-group"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Input Group</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/jumbotron"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Jumbotron</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/layout-grid-system"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Layout and Grid System</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/link"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Link</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/list-group"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">List group</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/media"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Media</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/modal"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Modal</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <li-->
<!--            aria-haspopup="true"-->
<!--            data-menu-toggle="hover"-->
<!--            class="menu-item menu-item-submenu"-->
<!--            v-bind:class="{-->
<!--              'menu-item-open': hasActiveChildren('/vue-bootstrap/nav')-->
<!--            }"-->
<!--          >-->
<!--            <a href="#" class="menu-link menu-toggle">-->
<!--              <i class="menu-bullet menu-bullet-dot">-->
<!--                <span></span>-->
<!--              </i>-->
<!--              <span class="menu-text">Navigation</span>-->
<!--              <i class="menu-arrow"></i>-->
<!--            </a>-->
<!--            <div class="menu-submenu">-->
<!--              <span class="menu-arrow"></span>-->
<!--              <ul class="menu-subnav">-->
<!--                <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--                  <span class="menu-link">-->
<!--                    <span class="menu-text"></span>-->
<!--                  </span>-->
<!--                </li>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/nav"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Nav</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/navbar"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Navbar</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li-->
<!--            aria-haspopup="true"-->
<!--            data-menu-toggle="hover"-->
<!--            class="menu-item menu-item-submenu"-->
<!--            v-bind:class="{-->
<!--              'menu-item-open': hasActiveChildren('/vue-bootstrap/pagination')-->
<!--            }"-->
<!--          >-->
<!--            <a href="#" class="menu-link menu-toggle">-->
<!--              <i class="menu-bullet menu-bullet-dot">-->
<!--                <span></span>-->
<!--              </i>-->
<!--              <span class="menu-text">Pagination</span>-->
<!--              <i class="menu-arrow"></i>-->
<!--            </a>-->
<!--            <div class="menu-submenu">-->
<!--              <span class="menu-arrow"></span>-->
<!--              <ul class="menu-subnav">-->
<!--                <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--                  <span class="menu-link">-->
<!--                    <span class="menu-text"></span>-->
<!--                  </span>-->
<!--                </li>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/pagination"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Pagination</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/pagination-nav"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Pagination Nav</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li-->
<!--            aria-haspopup="true"-->
<!--            data-menu-toggle="hover"-->
<!--            class="menu-item menu-item-submenu"-->
<!--          >-->
<!--            <a href="#" class="menu-link menu-toggle">-->
<!--              <i class="menu-bullet menu-bullet-dot">-->
<!--                <span></span>-->
<!--              </i>-->
<!--              <span class="menu-text">Notify</span>-->
<!--              <i class="menu-arrow"></i>-->
<!--            </a>-->
<!--            <div class="menu-submenu">-->
<!--              <span class="menu-arrow"></span>-->
<!--              <ul class="menu-subnav">-->
<!--                <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--                  <span class="menu-link">-->
<!--                    <span class="menu-text"></span>-->
<!--                  </span>-->
<!--                </li>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/popover"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Popover</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/toasts"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Toasts</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/tooltip"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Tooltip</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </li>-->

<!--          <li-->
<!--            aria-haspopup="true"-->
<!--            data-menu-toggle="hover"-->
<!--            class="menu-item menu-item-submenu"-->
<!--          >-->
<!--            <a href="#" class="menu-link menu-toggle">-->
<!--              <i class="menu-bullet menu-bullet-dot">-->
<!--                <span></span>-->
<!--              </i>-->
<!--              <span class="menu-text">Progress</span>-->
<!--              <i class="menu-arrow"></i>-->
<!--            </a>-->
<!--            <div class="menu-submenu">-->
<!--              <span class="menu-arrow"></span>-->
<!--              <ul class="menu-subnav">-->
<!--                <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--                  <span class="menu-link">-->
<!--                    <span class="menu-text"></span>-->
<!--                  </span>-->
<!--                </li>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/progress"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Progress</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->

<!--                <router-link-->
<!--                  to="/vue-bootstrap/spinner"-->
<!--                  v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--                >-->
<!--                  <li-->
<!--                    aria-haspopup="true"-->
<!--                    data-menu-toggle="hover"-->
<!--                    class="menu-item"-->
<!--                    :class="[-->
<!--                      isActive && 'menu-item-active',-->
<!--                      isExactActive && 'menu-item-active'-->
<!--                    ]"-->
<!--                  >-->
<!--                    <a :href="href" class="menu-link" @click="navigate">-->
<!--                      <i class="menu-bullet menu-bullet-dot">-->
<!--                        <span></span>-->
<!--                      </i>-->
<!--                      <span class="menu-text">Spinner</span>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </router-link>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </li>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/table"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Table</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/vue-bootstrap/tabs"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Tabs</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </li>-->






<!--    <li-->
<!--      aria-haspopup="true"-->
<!--      data-menu-toggle="hover"-->
<!--      class="menu-item menu-item-submenu"-->
<!--      v-bind:class="{ 'menu-item-open': hasActiveChildren('/wizard/wizard') }"-->
<!--    >-->
<!--      <a href="#" class="menu-link menu-toggle">-->
<!--        <i class="menu-icon flaticon2-mail-1"></i>-->
<!--        <span class="menu-text">Wizard</span>-->
<!--        <i class="menu-arrow"></i>-->
<!--      </a>-->
<!--      <div class="menu-submenu">-->
<!--        <span class="menu-arrow"></span>-->
<!--        <ul class="menu-subnav">-->
<!--          <li aria-haspopup="true" class="menu-item menu-item-parent">-->
<!--            <span class="menu-link">-->
<!--              <span class="menu-text">Wizard</span>-->
<!--            </span>-->
<!--          </li>-->

<!--          <router-link-->
<!--            to="/wizard/wizard-1"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Wizard 1</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/wizard/wizard-2"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Wizard 2</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/wizard/wizard-3"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Wizard 3</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->

<!--          <router-link-->
<!--            to="/wizard/wizard-4"-->
<!--            v-slot="{ href, navigate, isActive, isExactActive }"-->
<!--          >-->
<!--            <li-->
<!--              aria-haspopup="true"-->
<!--              data-menu-toggle="hover"-->
<!--              class="menu-item"-->
<!--              :class="[-->
<!--                isActive && 'menu-item-active',-->
<!--                isExactActive && 'menu-item-active'-->
<!--              ]"-->
<!--            >-->
<!--              <a :href="href" class="menu-link" @click="navigate">-->
<!--                <i class="menu-bullet menu-bullet-dot">-->
<!--                  <span></span>-->
<!--                </i>-->
<!--                <span class="menu-text">Wizard 4</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </router-link>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </li>-->
  </ul>
</template>

<script>



export default {
  name: "KTMenu",

  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },




  }
};
</script>
